import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { GrooveSurfaceDirective } from '@groove/angular';

export interface ScheduleStripItem {
  readonly term: string;
  readonly detail: string;
}

/**
 * A term + one-liner three-up (Weekly / Biweekly / Floater cadences, on the
 * hub's price-and-scheduling beat). Small and reusable for any "three ways"
 * content beyond scheduling. Each item sits on a Groove bordered surface so
 * the row reads as a strip of tiles, not a bare definition list.
 */
@Component({
  selector: 'app-schedule-strip',
  imports: [GrooveSurfaceDirective],
  templateUrl: './schedule-strip.component.html',
  styleUrl: './schedule-strip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleStripComponent {
  readonly items = input.required<readonly ScheduleStripItem[]>();
  readonly label = input<string>();
}
